// Build information, automatically generated by `ng-info`
const build = {
    version: "25.2.0-SNAPSHOT",
    timestamp: "Wed Nov 04 2026 16:03:03 GMT+0100 (Central European Standard Time)",
    message: null,
    git: {
        user: null,
        branch: "HEAD",
        hash: "088d1d",
        fullHash: "088d1d8b19a9f66bcd3414fa8d8b0c925bdbe094"
    }
};

export default build;